import { request } from "utils/legacy_api";

export function create(lessonId) {
  const body = { id: lessonId };
  return request("/lessons_watched", { method: "POST", body });
}

export function destroy(lessonId) {
  return request(`/lessons_watched/${lessonId}`, { method: "DELETE" });
}
